import './Confirm.less';
import { useEffect, useRef } from 'react';
import i18n from '@/utils/i18n.ts';

export default function Confirm({
  title,
  content,
  show,
  onConfirm,
  onCancel = () => {},
  onClose,
  showClose = true,
  okText = i18n.t('As_CreateProjectTrans_PopUpConfirm'),
  cancelText = i18n.t('As_CreateProjectTrans_PopUpCancel'),
  okIsPrimary = true,
  cancelIsPrimary = false,
  okIsRight = true,
}) {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (show) {
      dialogRef.current.show();
      dialogRef.current.addEventListener(
        'close',
        () => {
          onClose && onClose();
        },
        {
          once: true,
        },
      );
    }
  }, [show]);

  function handleConfirm() {
    onConfirm && onConfirm();
    dialogRef.current.close();
  }

  function handleCancel() {
    onCancel && onCancel();
    dialogRef.current.close();
  }
  return (
    <div className="confirm-component">
      <dialog ref={dialogRef} className="modal">
        <div className="modal-box">
          <form method="dialog">
            {/* if there is a button in form, it will close the modal */}
            {showClose && (
              <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
            )}
          </form>

          <h3 className="font-bold text-lg">{title}</h3>
          <p className="py-4">{content}</p>

          <div className="footer-action">
            {!okIsRight && (
              <button className={`btn ${okIsPrimary && 'btn-primary'}`} onClick={handleConfirm}>
                {okText}
              </button>
            )}
            <button className={`btn ${cancelIsPrimary && 'btn-primary'}`} onClick={handleCancel}>
              {cancelText}
            </button>
            {okIsRight && (
              <button className={`btn ${okIsPrimary && 'btn-primary'}`} onClick={handleConfirm}>
                {okText}
              </button>
            )}
          </div>
        </div>
      </dialog>
    </div>
  );
}
